import React from 'react'
import { Header } from '../GenericComponents/PageFrame/Header'
import { Footer } from '../GenericComponents/PageFrame/Footer'
export function PageNotFound() {
    return (
        <>
            <Header />
            <div className="container">
                <div className="row">
                    <div className="col-6">
                        <div className="content_page">
                            <h2 className="header">Page Not Found</h2>
                            <p>Sorry, we could not find this page. We apologize for the inconvenience.</p>
                            <p className="sub-header-highlight padding-top-largest">Possible reasons for this error: </p>
                            <ul className="ul-info">
                                <li>You might have misspelled the page name.</li>
                                <li>The link you used is out of date.</li>
                                <li>This page is temporarily unavailable.</li>
                            </ul>
                            <p className="sub-header-highlight padding-top-largest">What's Next?</p>
                            <ul className="ul-info">
                                <li>Please click back and retry your previous operation.</li>
                            </ul>
                        </div>
                    </div>
                    <div className="col-6">
                        <h2 className="header">Contact Support</h2>
                        <p>Having problem using the application? <a id="link_contact" href="#contact">Contact support</a>.</p>
                    </div>
                </div>
            </div>
            <Footer alignment='between' />
        </>
    )
}
